/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-indent */
import React, { useState, useEffect } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import {
  Button, Form, FormGroup, Label, Input, Alert, Modal, ModalBody
} from 'reactstrap'
import checkIcon from '../../../assests/images/check-round-icon.svg'
import { verifyEmail, verifyPassword, verifyLength } from '../../../helper'
import { login } from '../../../actions/auth'
import PropTypes from 'prop-types'

function LoginForm (props) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [errPassword, setErrPassword] = useState('')
  const [errEmail, setErrEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const [alert] = useState(null)
  const [message, setMessage] = useState('')
  const [modalMessage, setModalMessage] = useState(false)
  const toggleMessage = () => setModalMessage(!modalMessage)
  const dispatch = useDispatch()
  const resStatus = useSelector(state => state.auth.resStatus)
  const resMessage = useSelector(state => state.auth.resMessage)
  // const previousProps = useRef({ resMessage }).current

  // function hideAlert() {
  //   setAlert(null)
  // }

  useEffect(() => {
    if (props.location.state) {
      if (props.location.state.message) {
        setModalMessage(true)
        setMessage(props.location.state.message)
      }
      // props.history.replace()
    }
  }, [])

  useEffect(() => {
    setLoading(false)
  }, [resStatus, resMessage])

  function handleChange (event, type) {
    switch (type) {
      case 'Email':
        if (verifyLength(event.target.value, 1) && verifyEmail(event.target.value)) {
          setErrEmail('')
        } else if (!verifyLength(event.target.value, 1)) {
          setErrEmail('Required field')
        } else {
          setErrEmail('Invalid email')
        }
        setEmail(event.target.value)
        break
      case 'Password':
        if (verifyPassword(event.target.value)) {
          setErrPassword('')
        } else {
          setErrPassword('Must contain minimum 5 characters and maximum 14 characters')
        }
        setPassword(event.target.value)
        break
      default:
        break
    }
  }

  function logIn (e) {
    e.preventDefault()
    if (verifyLength(email, 1) && verifyLength(password, 1) && verifyEmail(email) && verifyPassword(password)) {
      dispatch(login(email, password))
    } else {
      if (!verifyLength(email, 1)) {
        setErrEmail('Required field')
      }
      if (!verifyLength(password, 1)) {
        setErrPassword('Required field')
      }
    }
  }

  return (
    <div className="form-section">
      {loading}
      {alert}
      {!resStatus && resMessage &&
        <Alert color="danger" isOpen={!resStatus}>
          {resMessage}
        </Alert>
      }
      <Form onSubmit={logIn}>
        <FormGroup>
          <Label for="email">Email</Label>
          <Input type="email" name="email" id="email" placeholder="Enter Your Email" value={email} onChange={(e) => { handleChange(e, 'Email') }} />
          <p className="error-text">{errEmail}</p>
        </FormGroup>
        <FormGroup>
          <Label for="password">Password</Label>
          <Input type="password" name="password" id="password" placeholder="Enter Your Password" value={password} onChange={(e) => { handleChange(e, 'Password') }} />
          <p className="error-text">{errPassword}</p>
        </FormGroup>
        <Button type="submit" className="theme-btn full-btn">login</Button>
      </Form>
      {/* <div className="form-footer text-center small-text">
        <NavLink to="/auth/forgotpassword">Forgot Password ?</NavLink>
    </div> */}
      <Modal isOpen={modalMessage} toggle={toggleMessage} className="modal-approve">
        <ModalBody className="text-center">
          <img className="info-icon" src={checkIcon} alt="check" />
          <h2>Success</h2>
          <p className="small-text light-text">{message}</p>
          <Button type="submit" className="theme-btn success-btn full-btn" onClick={toggleMessage}>OK</Button>
        </ModalBody>
      </Modal>
    </div>
  )
}

LoginForm.propTypes = {
  location: PropTypes.object,
  history: PropTypes.object
}
export default connect()(LoginForm)
